import styled, { css } from 'styled-components';

export const Container = styled.button<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    opacity: ${disabled ? 0.6 : 1};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};

    background-color: ${theme.palette.neutral[50]};
    border: 1px solid ${theme.palette.neutral[300]};
    border-radius: 1rem;

    padding: ${theme.layout.spacing(2)};

    display: flex;
    align-items: center;
    justify-content: space-between;

    transition: 0.2s;

    &:hover {
      border-color: ${theme.palette.primary.main};
    }

    > div {
      display: flex;
      align-items: center;
      gap: ${theme.layout.spacing(2)};

      svg {
        color: ${theme.palette.primary.main};
        font-size: 2rem;
      }

      span {
        color: ${theme.palette.text.main};
        font-size: ${theme.typography.sizes.body2};
        font-weight: 500;
        text-align: left;

        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
      }
    }

    > svg {
      color: ${theme.palette.primary.main};
      font-size: 1.5rem;
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      padding: ${theme.layout.spacing(4)};

      > div {
        gap: ${theme.layout.spacing(4)};

        svg {
          color: ${theme.palette.primary.main};
          font-size: 2.5rem;
        }

        span {
          font-size: ${theme.typography.sizes.subtitle};
        }
      }
    }
  `}
`;
